import { render, staticRenderFns } from "./platformInfo.vue?vue&type=template&id=7a9f07e1&scoped=true&"
import script from "./platformInfo.vue?vue&type=script&lang=js&"
export * from "./platformInfo.vue?vue&type=script&lang=js&"
import style0 from "./platformInfo.vue?vue&type=style&index=0&id=7a9f07e1&scoped=true&lang=css&"
import style1 from "./platformInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f07e1",
  null
  
)

export default component.exports